/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  Delete2PathParameters,
  GetOne1PathParameters,
  SmsSimulatorRuleDTO,
  SmsSimulatorRuleRequest,
  UpdateDescriptionPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getSmsSimulatorRule = () => {
  /**
 * Get all sms simulator rules

Required authority: PERM_SUPER_ADMIN
 */
  const getAll = () => {
    return customInstance<SmsSimulatorRuleDTO[]>({
      url: `/api/sms-simulator/rules`,
      method: "GET",
    });
  };
  /**
 * Update all sms simulator rules with their new order

Required authority: PERM_SUPER_ADMIN
 */
  const updateAll = (smsSimulatorRuleRequest: SmsSimulatorRuleRequest[]) => {
    return customInstance<SmsSimulatorRuleDTO[]>({
      url: `/api/sms-simulator/rules`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: smsSimulatorRuleRequest,
    });
  };
  /**
 * Create a sms simulator rule

Required authority: PERM_SUPER_ADMIN
 */
  const create = (smsSimulatorRuleRequest: SmsSimulatorRuleRequest) => {
    return customInstance<SmsSimulatorRuleDTO>({
      url: `/api/sms-simulator/rules`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smsSimulatorRuleRequest,
    });
  };
  /**
 * Get a sms simulator rule by id

Required authority: PERM_SUPER_ADMIN
 */
  const getOne1 = ({ id }: GetOne1PathParameters) => {
    return customInstance<SmsSimulatorRuleDTO>({
      url: `/api/sms-simulator/rules/${id}`,
      method: "GET",
    });
  };
  /**
 * Delete a sms simulator rule

Required authority: PERM_SUPER_ADMIN
 */
  const delete2 = ({ id }: Delete2PathParameters) => {
    return customInstance<void>({ url: `/api/sms-simulator/rules/${id}`, method: "DELETE" });
  };
  /**
 * Update description of a sms simulator rule

Required authority: PERM_SUPER_ADMIN
 */
  const updateDescription = (
    { id }: UpdateDescriptionPathParameters,
    smsSimulatorRuleRequest: SmsSimulatorRuleRequest,
  ) => {
    return customInstance<SmsSimulatorRuleDTO>({
      url: `/api/sms-simulator/rules/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: smsSimulatorRuleRequest,
    });
  };
  return { getAll, updateAll, create, getOne1, delete2, updateDescription };
};
export type GetAllResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["getAll"]>>
>;
export type UpdateAllResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["updateAll"]>>
>;
export type CreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["create"]>>
>;
export type GetOne1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["getOne1"]>>
>;
export type Delete2Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["delete2"]>>
>;
export type UpdateDescriptionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSmsSimulatorRule>["updateDescription"]>>
>;
